<template>
    <!-- maincss Login Modal -->

    <div
        class="modal login-form-popup fade h-auto"
        id="design-studio"
        tabindex="-1"
        aria-labelledby="design-studio"
        data-backdrop="static"
    >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-body">
                    <a
                        href="javascript:;"
                        class="popup-close"
                        id="popup-close"
                        data-dismiss="modal"
                    >
                        <img src="/maincss/images/cancel.svg" alt=" " />
                    </a>
                    <div class="login-form">
                        <h3>Alert!</h3>
                        <p>
                            In Order to save designs you need to select a
                            product
                        </p>
                        <a
                            href="/category/apparel"
                            class="btn btn-link btn_outline_primary border_primary_blue text_primary_blue"
                        >
                            Click Here
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { LOGIN, REGISTER, LOGOUT } from "@/store/actions.type";
import ApiService from "@/common/api.service";

export default {
    data() {
        return {
            login_data: [
                {
                    email: null,
                    password: null
                }
            ],
            registration_data: [
                {
                    first_name: null,
                    last_name: null,
                    email: null,
                    password: null,
                    confirm_password: null,
                    accept_terms: null
                }
            ],
            resetform_data: [
                {
                    email: null
                }
            ],
            redirect_path: "/MyAccount"
        };
    },
    mounted() {
        var _this = this;
        /* eslint-disable */
        $(document).on("hide.bs.modal", "#login", function () {
            _this.$validator.reset();
            _this.login_data = [
                {
                    email: null,
                    password: null
                }
            ];
            //Do stuff here
        });
        $(document).on("click", ".login-cart", function () {
            console.log($(this).data("path"));
            _this.redirect_path = $(this).data("path");
        });
        /* eslint-enable */
    },
    methods: {
        logout() {
            this.$store.dispatch(LOGOUT).then(() => {
                this.$router.push({ path: "/" });
            });
        },
        onSubmitToLogin() {
            var _this = this;

            _this.$validator.validateAll("loginform").then((isValid) => {
                if (isValid) {
                    _this.$store
                        .dispatch(LOGIN, {
                            email: _this.login_data.email,
                            password: _this.login_data.password
                        })
                        .then((response) => {
                            if (response.success) {
                                _this.$toast.success("Login Successfully.", {
                                    position: "top-right"
                                });
                                document.getElementById("popup-close").click();
                                _this.$root.$emit("update-cart");
                                _this.syncCart();
                                this.$router.push({
                                    path: _this.redirect_path
                                });
                            } else {
                                let field =
                                    response.error == "Invalid password"
                                        ? "password"
                                        : "email";
                                _this.errors.itemslength = 0;
                                _this.errors.items.push({
                                    id: 1,
                                    vmId: _this.errors.vmId,
                                    field: field,
                                    msg: response.error,
                                    scope: "loginform"
                                });
                                console.log("login error", _this.errors);
                            }
                        });
                } else {
                    console.log("gjhghj", _this.errors);
                }
            });
        },
        syncCart() {
            var _this = this;
            if (localStorage.getItem("cart")) {
                let cart = JSON.parse(localStorage.getItem("cart"));
                new Promise(() => {
                    let post_data = {
                        items: cart.items,
                        totalQty: cart.totalQty,
                        totalPrice: cart.totalPrice
                    };
                    ApiService.setHeader();
                    ApiService.post("/sync-cart", post_data)
                        .then(({ data }) => {
                            console.log(data);
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            }

            console.log(_this.cart_items);
        },
        onSubmitToRegister() {
            this.$validator.validateAll("signupform").then((isValid) => {
                if (isValid) {
                    this.$store
                        .dispatch(REGISTER, {
                            first_name: this.registration_data.first_name,
                            last_name: this.registration_data.last_name,
                            email: this.registration_data.email,
                            password: this.registration_data.password,
                            confirm_password:
                                this.registration_data.confirm_password
                        })
                        .then((response) => {
                            console.log(response);
                            /* eslint-disable */
                            _this.$toast.success(
                                "User registered Successfully.",
                                {
                                    position: "top-right"
                                }
                            );
                            $("#register").modal("hide");
                            /* eslint-enable */
                            this.$router.push({ path: "/" });
                        });
                } else {
                    console.log("gjhghj", this.errors);
                }
            });
        },
        onSubmitToResetPassword() {
            this.$validator.validateAll("signupform").then((isValid) => {
                if (isValid) {
                    this.$store
                        .dispatch(REGISTER, {
                            email: this.registration_data.email
                        })
                        .then((response) => {
                            console.log(response);
                            /* eslint-disable */
                            $("#register").modal("hide");
                            /* eslint-enable */
                            this.$router.push({ path: "/" });
                        });
                } else {
                    console.log("gjhghj", this.errors);
                }
            });
        }
    }
};
</script>
<style>
.modal.modal-static {
    transform: none !important;
}

#design-studio {
    overflow-y: auto !important;
}

.modal.fade {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -ms-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
}
</style>
